export default [
  {
    title: 'Home',
    route: 'home-dashboard',
    icon: 'HomeIcon',
  }
]
